export default [4, 50, 11, 35];